'use client';

import { PaginationData } from '@/app/lib/schemas/types/shared';
import { useAppDispatch } from '@/app/lib/store/hooks';
import { updateSearchParams } from '@/app/lib/store/search-params-slice';
import { updateTopicId } from '@/app/lib/store/topic-slice';
import { updateCount } from '@/app/lib/store/total-pages-slice';
import { useEffect, useState } from 'react';

interface Props {
  data: PaginationData;
  children: React.ReactNode;
}

export default function PaginationClientProvider({ data, children }: Props) {
  const { total, topicId, searchParams } = data;
  const dispatch = useAppDispatch();

  //Предотвращаем проблему с гидратацией
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (isClient) {
      dispatch(updateCount(total));
      dispatch(updateTopicId(topicId));
      dispatch(updateSearchParams(searchParams));
    }
  }, [isClient, dispatch, total, topicId, searchParams]);

  return <>{children}</>;
}
